import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import i18n from '../../../../utils/i18n';

const followerGrowthOptions = (data) => {
  const categories = [];
  const cleanData = [];

  (data || []).map(d => {
    categories.push(d.date);
    categories.push(d.followers);
  });

  return {
    title: null,
    xAxis: {
      categories,
      title: {
        text: i18n.t('influencers.common.date')
      },
      accessibility: {
        description: i18n.t('influencers.common.date')
      }
    },
    yAxis: {
      title: {
        text: i18n.t('influencers.common.followers')
      }
    },
    legend: {
      enabled: false
    },
    series: [{
      name: i18n.t('influencers.common.followers'),
      data: cleanData
    }],
    lang: {
      noData: i18n.t('influencers.pages.analytics.not_enough_data')
    },
    noData: {
      style: {
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#303030'
      }
    },
    credits: {
      enabled: false
    },
  };
};


const FollowerGrowth = ({
  data,
}) => {
  if (!data) return null;

  const options = useMemo(() =>
    followerGrowthOptions(get(data, 'stats.follower_growth_364_days', []))
    , [data]);

  // If not data on chart doesn't show it
  if (!get(options, 'series[0].cleanData', []).length) return null;

  return (<React.Fragment>

    <h4 className='mb-5'>
      {i18n.t('influencers.pages.analytics.follower_growth')}
    </h4>

    <div className="mb-6">
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        containerProps={{ className: 'border border-dark border-radius-1' }}
        />
    </div>
  </React.Fragment >);
};

export default React.memo(FollowerGrowth);